/**
 * Pairing codes a player shows (spec §2.3): 8 chars of Crockford base32,
 * rendered `XXXX-XXXX`. A scan yields the console's claim URL
 * (`…/claim?code=…`); a person may type the bare code in any case.
 */

const CROCKFORD = /^[0-9A-HJKMNP-TV-Z]{8}$/;

/** Normalise a typed or scanned code to `XXXX-XXXX`, or null if it can't be one. */
export function normalisePairingCode(raw: string): string | null {
  const compact = raw
    .toUpperCase()
    .replace(/[^0-9A-Z]/g, '')
    .replace(/[IL]/g, '1')
    .replace(/O/g, '0')
    .replace(/U/g, 'V');
  return CROCKFORD.test(compact) ? `${compact.slice(0, 4)}-${compact.slice(4)}` : null;
}

/** The pairing code in a QR payload — a claim URL or a bare code — or null. */
export function pairingCodeFromScan(text: string): string | null {
  const trimmed = text.trim();
  if (/^https?:\/\//i.test(trimmed)) {
    try {
      const code = new URL(trimmed).searchParams.get('code');
      return code ? normalisePairingCode(code) : null;
    } catch {
      return null;
    }
  }
  return normalisePairingCode(trimmed);
}

/**
 * Whether a QR payload is an Akarya Player's LAN registration code
 * (`akarya://player?…`, for the portable CMS) rather than a cloud pairing QR.
 */
export function isPortablePlayerLink(text: string): boolean {
  return /^akarya:\/\/player\?/i.test(text.trim());
}
